import { defineStore } from 'pinia'

export const useEnvStore = defineStore('env', () => {
  const apiBase = useRuntimeConfig().public.apiBase

  const recaptchaSitekey = useRuntimeConfig().public.recaptchaSitekey

  const baseURL = useRuntimeConfig().public.baseURL

  return {
    apiBase,
    recaptchaSitekey,
    baseURL
  }
})
